"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
/**
 * Get custom icon for special folders like inbox, drafts, sent, deleted, etc.
 * @param showNonSpecialFolderIcon Whether to show generic folder icon
 */
function getCustomIcon(folderId, showNonSpecialFolderIcon) {
    switch (folderId) {
        case folderNameToId_1.default('inbox'):
            return "Inbox" /* Inbox */;
        case folderNameToId_1.default('sentitems'):
            return "Send" /* Send */;
        case folderNameToId_1.default('drafts'):
            return "Edit" /* Edit */;
        case folderNameToId_1.default('deleteditems'):
            return "Delete" /* Delete */;
        case folderNameToId_1.default('archive'):
            return "Archive" /* Archive */;
        case folderNameToId_1.default('junkemail'):
            return "Blocked" /* Blocked */;
        default:
            break;
    }
    if (showNonSpecialFolderIcon) {
        return "FabricFolder" /* FabricFolder */;
    }
    else {
        return null;
    }
}
exports.default = getCustomIcon;
//# sourceMappingURL=getCustomIcon.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getCustomIcon.js
// module id = 5187
// module chunks = 2